const Modules = ({ data }) => {
  if (!data) return null;

  const tooltips = [
    "This helps you handle all tax-related stuff! Think of it as having a tax expert who makes sure everything is checked, flagged, and ready for your finance team to review.",
    "This organizes all the people-related info! It tracks who works where, what they do, and any potential issues when bringing new teams on board.",
    "Your tech security guard! It checks systems, cybersecurity, and data protection - basically making sure everything is secure and up to standard.",
    "This bridges the gap between winning a contract and actually doing the work! It creates a clear roadmap so you don't have to start from scratch after award.",
    "Your vendor history tracker! It keeps records of past performance and open issues, helping you make better decisions when choosing partners.",
    "Your legal safety net! It automatically checks every document against FAR/DFARS rules and builds protest-proof documentation as you go."
  ];

  return (
    <section className="py-16 px-6" data-testid="modules-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold mb-4">{data.title}</h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {data.items.map((module, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
              data-testid={`module-${index}`}
              data-robot-tooltip={tooltips[index]}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/10 to-blue-600/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <h3 className="text-lg font-semibold mb-3 text-gray-900">
                  {module.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {module.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed text-center">
          The objective: reduce low-value manual work, improve consistency across evaluators, and strengthen defensibility, without losing oversight.
        </p>
      </div>
    </section>
  );
};

export default Modules;
